import { DeliveryError } from '@contracts/delivering/DeliveryError';

const deliveryErrorTranslationKeyByCode: Record<DeliveryError, string> = {
  [DeliveryError.InvalidPhoneNumber]: `issuePermitMessage.error.${DeliveryError.InvalidPhoneNumber}`,
  [DeliveryError.BlockedPhoneNumber]: `issuePermitMessage.error.${DeliveryError.BlockedPhoneNumber}`,
  [DeliveryError.PhoneNumberCannotReceiveSms]: `issuePermitMessage.error.${DeliveryError.PhoneNumberCannotReceiveSms}`,
  [DeliveryError.TechnicalErrorWhileSendingSms]: `issuePermitMessage.error.${DeliveryError.TechnicalErrorWhileSendingSms}`,
  [DeliveryError.UnsupportedSmsLanguage]: `issuePermitMessage.error.${DeliveryError.UnsupportedSmsLanguage}`,
  [DeliveryError.UnauthorizedSmsDelivery]: `issuePermitMessage.error.${DeliveryError.UnauthorizedSmsDelivery}`,
  [DeliveryError.CannotDeliver]: `issuePermitMessage.error.${DeliveryError.CannotDeliver}`,
};

const isDeliveryError = (value: string): value is DeliveryError =>
  (Object.values(DeliveryError) as string[]).includes(value);

export const getDeliveryErrorTranslationKey = (
  error: string | undefined,
): string | undefined => {
  if (error === undefined || !isDeliveryError(error)) {
    return undefined;
  }
  return deliveryErrorTranslationKeyByCode[error];
};
